import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BoardTrendChooser from 'components/molecules/Board/BoardTrendChooser';
import { actionCreators, getIsMeasurmentDiagramLoading, getMeasurmentDiagramSelectedType } from 'store/dashboard';

const mapStateToProps = (state: any) => ({
	selected: getMeasurmentDiagramSelectedType(state),
	isLoading: getIsMeasurmentDiagramLoading(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			onChange: actionCreators.doRequestMeasurementDiagram,
		},
		dispatch
	);
};

export default connect<ReturnType<typeof mapStateToProps>, any, any>(
	mapStateToProps,
	mapDispatchToProps
)(BoardTrendChooser);
